import { useGetProgressQuery } from "../progressSlice";

const useProgressPreview = () => {
  const progress = useGetProgressQuery();

  return { ...progress, progress: progress?.data || [] };
};

export default useProgressPreview;
